import React from 'react';
import './Wavy.css';

const Wavy = () => {
    return (
        <div className="wavy__wrapper">
            <section>
                <div className="wave">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div className="content">
                    <h2>
                        <span>d</span>
                        <span>o</span>
                        <span>nate</span>
                        <br />
                        <i></i>
                    </h2>
                </div>
            </section>
        </div>
    )
}

export default Wavy
